import React, { useEffect } from "react";
import useForm, { Form } from "../../../../../hooks/useForm";
import Controls from "../../../../../components/form/controls/Controls";
import { isDisableSubmit } from "../../../utils";
import { validationFLFRogoDevSubTypeInput } from "../../../utils/validateInput";
import { useState } from "react";

const initialValue = {
  id: "",
  name: "",
  devSubTypeCode: 0,
  devSubTypeStr: "",
};

function FLFRogoDevSubTypeForm(props) {
  const { addOrEdit, recordForEdit, errorsForm } = props;
  const [valueAddNew, setValueAddNew] = useState(initialValue);

  // validation input permission
  const validateFLFRogoDevSubTypeForm = (fieldValues = values) => {
    let temp = validationFLFRogoDevSubTypeInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialValue, true, validateFLFRogoDevSubTypeForm);

  const onSubmit = (e) => {
    e.preventDefault();
    if (validateFLFRogoDevSubTypeForm()) {
      addOrEdit(values, resetForm);
      setValueAddNew(initialValue);
    }
  };

  useEffect(() => {
    setErrors({
      ...errorsForm,
    });
  }, [errorsForm, setErrors]);

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues({
        ...recordForEdit,
      });
    } else {
      setValues({
        ...valueAddNew,
      });
      setErrors({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordForEdit]);

  const handleOnChange = (e) => {
    handleInputChange(e);

    if (!recordForEdit) {
      const { name, value, type } = e.target;
      setValueAddNew({
        ...valueAddNew,
        [name]: type === "number" ? +value : value,
      });
    }
  };

  return (
    <Form onSubmit={onSubmit}>
      <Controls.Input
        name="name"
        value={values.name}
        label="Name"
        type="text"
        onChange={handleOnChange}
        error={errors.name}
      />

      <Controls.Input
        name="devSubTypeCode"
        value={values.devSubTypeCode}
        label="Rogo Dev Type Code"
        type="number"
        onChange={handleOnChange}
        error={errors.devSubTypeCode}
      />
      <Controls.Input
        name="devSubTypeStr"
        value={values.devSubTypeStr}
        label="Rogo Dev Type String"
        type="text"
        onChange={handleOnChange}
        error={errors.devSubTypeStr}
      />

      <Controls.Button
        sx={{ width: "100%", marginTop: "10px" }}
        type="submit"
        text="Submit"
        disabled={isDisableSubmit(recordForEdit, values)}
      />
    </Form>
  );
}

export default FLFRogoDevSubTypeForm;
